import { VoidCallback } from '@deqo/foundation';
import { EventRouter } from '@deqo/podopolis';
import { injectable } from 'inversify';
import { ActiveObject, resolve } from '../../Container';
import { Camera, CameraState } from '../Camera';
import { StateProperty, StatePropertyRef } from '../ExtendableStore';

export type SuggestedWidgetScaleOption = 'smallest' | 'small' | 'normal';
export const SuggestedWidgetScale = StatePropertyRef<SuggestedWidgetScaleOption>('suggestedWidgetScale', 'normal');

@injectable()
export class SuggestedWidgetScaleProperty extends ActiveObject implements StateProperty<SuggestedWidgetScaleOption> {

    @resolve(Camera) private camera!: Camera;

    private router = new EventRouter<any>();
    private value = 'normal' as SuggestedWidgetScaleOption;

    public start = () => this.burden(
        this.camera.observe(this.flush),
    );

    public readonly name = SuggestedWidgetScale.name;
    public readonly writable = false;

    public get(): SuggestedWidgetScaleOption {
        return this.value;
    }

    public watch(callback: VoidCallback): VoidCallback {
        return this.router.on('change', () => callback());
    }

    private flush = ({ height }: CameraState) => {
        const next = this.switchValue(height);
        if (this.value !== next) {
            this.value = next;
            this.router.emit('change', {});
        }
    };

    private switchValue = (height: number) => {
        if (height < 720) return 'smallest';
        if (height < 780) return 'small';
        return 'normal';
    };
}
